import images from "./images";

const pricing = [
  {
    id: 1,
    image: images.plan1,
    title: 'Sweet Treats',
    content: 'Perfect for small gatherings',
    price: 15,
    features: [
      'Assorted Cupcakes',
      'Brownies & Bars',
      'Cookies & Biscuits',
      'Custom Cake Slices',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    title: 'Festive Delight',
    content: 'Great for special occasions',
    price: 40,
    features: [
      'Custom Celebration Cakes',
      'Assorted Pastries',
      'Cake Pops & Mini Cakes',
      'Cupcake Towers',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    title: 'Majestic Festivities',
    content: 'Perfect for large gatherings',
    price: 100,
    features: [
      'Custom Wedding Cakes',
      'Specialty Breads',
      'Event Catering',
      'Personalized Consultation',
    ],
  },
];

export default pricing;